import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import debounce from "./utils/debounce";
import { connectRouter } from "connected-react-router";

import RouteChange from "./utils/RouteChange";

import initialFetchAllReducer from "./reducers/initialFetchAll";
import optionsReducer from "./reducers/options";
import pageReducer from "./reducers/page";
import uiReducer from "./reducers/ui";
import tagsCounterReducer from "./reducers/tagsCounter";
import contentTagsReducer from "./reducers/contentTags";
import eventsReducer from "./reducers/events";
import clubsReducer from "./reducers/clubs";
import userReducer from "./reducers/user";
import cartReducer from "./reducers/cart";
import lastActionReducer from "./reducers/lastAction";
import { wp } from "./services/wp";
import { setupListeners } from "@reduxjs/toolkit/query";

// History object for redux
export const history = createBrowserHistory({
    basename: "/",
});

// Create single array for all middlewares and add logger when needed only
const middleware = [wp.middleware, routerMiddleware(history), RouteChange];

// Include redux logger middleware only for local development
if (process.env.NODE_ENV !== "production") {
    middleware.push(
        createLogger({
            collapsed: true,
        })
    );
}

// Initial State
const preloadedState = {};

const store = configureStore({
    reducer: {
        router: connectRouter(history),
        initialFetchAll: initialFetchAllReducer,
        options: optionsReducer,
        page: pageReducer,
        ui: uiReducer,
        tagsCounter: tagsCounterReducer,
        contentTags: contentTagsReducer,
        events: eventsReducer,
        clubs: clubsReducer,
        user: userReducer,
        cart: cartReducer,
        lastAction: lastActionReducer,
        [wp.reducerPath]: wp.reducer,
    },
    preloadedState,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(...middleware),
});

setupListeners(store.dispatch);

// subscibe to store changes
store.subscribe(
    // store cart in localstorage
    debounce(() => {
        window.localStorage.setItem(
            "cart",
            JSON.stringify(store.getState().cart)
        );
    })
);

export default store;
